<template>
  <button :class="button({ variant: 'secondary', size: 'lg', class: 'w-full' })">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { button } from '@carvia/theme/lib/cva/button';
</script>
